import React, { useState } from 'react';
import './App.css';
import { useBrands } from './BrandsContext';
import { getGlobalDealerName, getGlobalDealerID } from './globalState';
import api from './api';
import BackButton from './BackButton';

const MAX_LENGTH = 2000;

function Support() {
  const brands = useBrands();
  const [selectedBrand, setSelectedBrand] = useState(getGlobalDealerName() || '');
  const [dealerID, setDealerID] = useState(getGlobalDealerID() || '');
  const [supportQuestion, setSupportQuestion] = useState('');
  const [status, setStatus] = useState(null); // null | 'submitting' | 'success' | 'error'
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedBrand || !dealerID || !supportQuestion.trim()) {
      setErrorMessage('Please fill in all fields.');
      return;
    }
    setStatus('submitting');
    setErrorMessage('');
    try {
      await api.post('/api/send-support', { selectedBrand, dealerID, supportQuestion });
      setStatus('success');
    } catch (err) {
      const msg = err.response?.data?.error || 'Could not submit your request. Please try again.';
      setErrorMessage(msg);
      setStatus('error');
    }
  };

  if (status === 'success') {
    return (
      <div className="Support">
        <h1 className="Support-title">Request received</h1>
        <p className="Support-text">
          Our dealer support team will follow up with you shortly.
        </p>
        <BackButton />
      </div>
    );
  }

  return (
    <div className="Support">
      <h1 className="Support-title">Have a question? We're here to help</h1>
      <form className="Support-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="support-brand">Brand</label>
          <select
            id="support-brand"
            className="Support-dropdown"
            value={selectedBrand}
            onChange={(e) => setSelectedBrand(e.target.value)}
            required
          >
            <option value="">Select your brand</option>
            {brands.map((b) => (
              <option key={b.name} value={b.name}>{b.name}</option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <label htmlFor="support-dealer-id">Dealer ID</label>
          <input
            id="support-dealer-id"
            type="text"
            value={dealerID}
            onChange={(e) => setDealerID(e.target.value)}
            placeholder="Enter your Dealer ID"
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="support-question">
            Question ({supportQuestion.length}/{MAX_LENGTH})
          </label>
          <textarea
            id="support-question"
            value={supportQuestion}
            onChange={(e) => setSupportQuestion(e.target.value.slice(0, MAX_LENGTH))}
            placeholder="Describe your question or issue..."
            required
          />
        </div>
        {errorMessage && <p className="DealerID-error">{errorMessage}</p>}
        <button
          type="submit"
          className="submit-button"
          disabled={status === 'submitting'}
        >
          {status === 'submitting' ? 'Submitting...' : 'Submit'}
        </button>
      </form>
      <BackButton />
    </div>
  );
}

export default Support;
